module.exports = __webpack_public_path__ + "static/media/first_medal.213b6e01.png";